import styled from 'styled-components';
import { Box } from '../Box/Box';
import { StyledForm, StyledFormFieldBanner, StyledFormRow } from '../Form/Form.styles';
import { mediaIE11Hack } from '../_styles/media';
import { spacing } from '../_styles/spacing';
export var StyledContent = /*#__PURE__*/styled(Box).withConfig({
  displayName: "StyledContent",
  componentId: "core-12_20_1__sc-10y57gh-0"
})(["> * + *,> * + h1,> * + h2,> * + h3,> * + h4,> * + p,> * + ul,> * + ol{margin-top:", "px;}> ", " + *{margin-top:0;}> ", ",> ", " > ", ",> ", "{", "{min-height:0;margin-bottom:", "px;}&:last-child ", "{margin-bottom:0;}}"], spacing.lg, StyledFormRow, StyledFormRow, StyledForm, StyledFormRow, StyledFormRow, StyledFormFieldBanner, spacing.md, StyledFormFieldBanner);
export var StyledActions = /*#__PURE__*/styled(Box).withConfig({
  displayName: "StyledActions",
  componentId: "core-12_20_1__sc-10y57gh-1"
})(["display:flex;justify-content:flex-end;gap:", "px;@media ", "{& > * + *{margin-left:", "px;}}"], spacing.sm, mediaIE11Hack, spacing.sm);
//# sourceMappingURL=Content.styles.js.map